
import cmsBlock from '~/mixins/cmsBlock'

export default {
  name: 'CmsMediclubSportHero',
  mixins: [cmsBlock],
  data () {
    return {
      fallbackContent: {
        title: '<b>Unlock</b> your potential',
        subtitle: 'and be well feel good enjoy your life',
        loggedTitle: 'Limited benefits',
        loggedSubtitle: 'Be the first and take advantage of offers that never come back',

        bgImg: {
          mobile: '/mc/v3/sport-hero/hero-mobile.png',
          desktop: '/mc/v3/sport-hero/hero.png',
        },

        items: [
          {
            title: '<b>5000</b>',
            text: 'Facilities in whole Poland, with modern equipment, at top locations',
          },
          {
            title: '<b>Limited</b> benefits',
            text: 'only for MediClub Members in sport area',
          },
          {
            title: '<b>1200</b>',
            text: 'persons taking part in our exclusive sport program',
          },
          {
            title: '<b>Extra</b> offerts',
            text: 'sport cards, personal trainings and workouts',
          },
          {
            title: '<b>-60 %</b>',
            text: 'take advantage of healthy nutrition with MediDiet',
          },
        ],
      },
    }
  },
}
